GameView = require "views/base/game"
Prefix = require("lib/prefix")
{ DraggyView }  = require("views/components/draggy")

class ReorderView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super

    longest = _.chain(data.list).sortBy("length").last().value()

    data.isLong = longest?.length > Math.min(data.width / 16, 30)
    data.shuffledList = _.shuffle(data.list or [])

    data

  show: ->
    super
    @listenTo this, "resize", @onResize

    if @draggies
      for draggy in @draggies
        draggy.undelegateEvents()

      @draggies = null

    draggies = @findAll(".draggy")
    @setEl @findOne(".draggy-container"), "container"

    @draggies =
      for el, i in draggies
        el.style.position = "absolute"
        draggy = new DraggyView
          el: el
          lock: "x"
          minY: 0

        @listenTo draggy, "drag", @onDrag
        @listenTo draggy, "drop", @onDrop

        draggy

    @onResize()
    @resetDraggies(@draggies)

    @enterGame()

  hide: ->
    @el.classList.remove "ready"
    super

  onDrag: (draggy, isInitialDrag) ->
    isActive = false
    rank = @getRanking(draggy)

    @resetDraggies(@draggiesInOrder(@draggies), draggy)

    @transform draggy.el,
      y: draggy.y
      scale: 1.05
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    {left, top, width, height} = draggy.offset

    rank = @getRanking(draggy)

    if isReset
      @transform draggy.el,
        y: draggy.y
        transition: "all 300ms"
    else
      @resetDraggies(@draggiesInOrder(@draggies))
      @setState("touched")

  draggiesInOrder: (draggies) ->
    if draggies and height = draggies[0]?.el.parentNode.offsetHeight

      _.clone(draggies).sort (a, b) ->
        (a.y + a.y / height * a.offset.height) -
        (b.y + b.y / height * b.offset.height)

  getRanking: (draggy) ->
    len = @options.data.list.length
    num = Math.floor(draggy.y / draggy.options.maxY * len)

    _.limit(num, 0, len - 1)

  getDraggyFromIndex: (index) ->
    (draggy for draggy in @draggies when draggy.el.dataset.index is index)[0]

  getElements: (selector) ->
    for el in @findAll(selector)
      el: el
      bounds: el.getBoundingClientRect()

  resetDraggy: (draggy) ->
    draggy.reset()
    draggy.el.classList.remove("is-positioned")

  resetDraggies: (draggies, draggy) ->
    y = 0

    for other, i in draggies or []
      other.reset({ y }) unless other is draggy
      y += other.offset.height

  isCorrect: ->
    _.chain(@draggiesInOrder(@draggies))
      .filter((d, i) -> +d.el.dataset.index is i)
      .each((d) -> d.el.classList.add("correct"))
      .size()
      .value() is @options.data.list.length

  showAnswer: ->
    @resetDraggies(_.sortBy @draggies, (d) -> +d.el.dataset.index)

  onResize: ->
    return unless @draggies?.length > 0

    reducer = (m, { el }) -> m + el.offsetHeight

    height = _.reduce @draggies, reducer, 0
    fontSize = parseInt window.getComputedStyle(@el).fontSize
    @getEl("container").firstChild.style.height = "#{height / fontSize}em"

    @fitText =>
      height = _.reduce @draggies, reducer, 0
      @getEl("container").firstChild.style.height = "#{height}px"

      for draggy, i in @draggies
        draggy.options.maxY = height - draggy.el.offsetHeight
        draggy.getOffset()

      @resetDraggies(@draggiesInOrder(@draggies))
      @el.classList.add "ready"

  answerDetails: ->
    questions    = @options.metadata?.questions or []
    return [] unless questions.length > 0

    question = questions[0]
    isCorrect = @isCorrect()
    answer = _.find question.answers, (a) -> a.correct is isCorrect
    answerContent =
      _.map @draggiesInOrder(@draggies), (d) -> d.$el.data("content")
    answer.content = answerContent.join(", ")
    details = question: questions[0].question, answer: answer

    [ details ]

  endGame: ->
    super

    @submit()


module.exports = ReorderView
